import type { LevelCatalogState } from "../types/level.types";

/** Initial taxonomy — same data previously in catalog-levels.ts */
export function buildLevelSeedState(): LevelCatalogState {
  const level1 = [
    { id: "vocals", label: "Vocals", sortOrder: 1 },
    { id: "instrumental", label: "Instrumental", sortOrder: 2 },
    { id: "playback-series", label: "Playback Series", sortOrder: 3 },
    { id: "music-for-children", label: "Music For Children", sortOrder: 4 },
    { id: "professional", label: "Professional", sortOrder: 5 },
    { id: "hobby-educational", label: "Hobby/ Educational", sortOrder: 6 },
  ];

  const level2 = [
    { id: "hindustani-vocals", label: "Hindustani Vocals", parentLevel1Id: "vocals", categorySlug: "hindustani-vocals", sortOrder: 1 },
    { id: "carnatic-vocals", label: "Carnatic Vocals", parentLevel1Id: "vocals", categorySlug: "carnatic-vocals", sortOrder: 2 },
    { id: "raga-deep-dive", label: "Raga Deep Dive", parentLevel1Id: "vocals", categorySlug: "raga-deep-dive", sortOrder: 3 },
    { id: "guitar", label: "Guitar", parentLevel1Id: "instrumental", categorySlug: "guitar", sortOrder: 1 },
    { id: "keyboard", label: "Keyboard", parentLevel1Id: "instrumental", categorySlug: "keyboard", sortOrder: 2 },
    { id: "piano", label: "Piano", parentLevel1Id: "instrumental", categorySlug: "piano", sortOrder: 3 },
    { id: "hindi-playback", label: "Hindi Playback Series", parentLevel1Id: "playback-series", categorySlug: "hindi-playback", sortOrder: 1 },
    { id: "tamil-playback", label: "Tamil Playback Series", parentLevel1Id: "playback-series", categorySlug: "tamil-playback", sortOrder: 2 },
    { id: "grow-with-music", label: "Grow With Music", parentLevel1Id: "music-for-children", categorySlug: "grow-with-music", sortOrder: 1 },
    { id: "hindustani-children", label: "Hindustani Music to Children", parentLevel1Id: "music-for-children", categorySlug: "hindustani-children", sortOrder: 2 },
    { id: "mother-tongue", label: "Mother Tongue Series", parentLevel1Id: "music-for-children", categorySlug: "mother-tongue", sortOrder: 3 },
    { id: "voice-gym", label: "Voice Gym", parentLevel1Id: "professional", categorySlug: "voice-gym", sortOrder: 1 },
    { id: "playback-singing", label: "Playback singing", parentLevel1Id: "professional", categorySlug: "playback-singing", sortOrder: 2 },
    { id: "heritage-series", label: "The Heritage Series", parentLevel1Id: "hobby-educational", categorySlug: "heritage-series", sortOrder: 1 },
    { id: "language-of-rhythm", label: "Language Of Rhythm", parentLevel1Id: "hobby-educational", categorySlug: "language-of-rhythm", sortOrder: 2 },
  ];

  const level3 = [
    { id: "age-above", label: "10 years above", sortOrder: 1 },
    { id: "age-below", label: "10 years below", sortOrder: 2 },
    { id: "age-above-female", label: "10 Years above - Female", sortOrder: 3 },
    { id: "age-below-male", label: "10 years below - Male", sortOrder: 4 },
  ];

  return { level1, level2, level3 };
}
